import { loader } from "graphql.macro";

const MPIRIMPA_QUERY = loader(
  "../../../Games/mpirimpa/CreateTable/graphql/MpirimpaDefaultConfigQuery.graphql"
);
const MPIRIMPA_MUTATION = loader(
  "../../../Games/mpirimpa/CreateTable/graphql/MpirimpaCreateOpenTableMutation.graphql"
);

const TICHU_QUERY = loader(
  "../../../Games/tichu/CreateTable/graphql/TichuDefaultConfigQuery.graphql"
);
const TICHU_MUTATION = loader(
  "../../../Games/tichu/CreateTable/graphql/TichuCreateOpenTableMutation.graphql"
);

const BACKGAMMON_QUERY = loader(
  "../../../Games/backgammon/CreateTable/graphql/BackgammonDefaultConfigQuery.graphql"
);
const BACKGAMMON_MUTATION = loader(
  "../../../Games/backgammon/CreateTable/graphql/BackgammonCreateOpenTableMutation.graphql"
);

const BELOTE_QUERY = loader(
  "../../../Games/belote/CreateTable/graphql/BeloteDefaultConfigQuery.graphql"
);
const BELOTE_MUTATION = loader(
  "../../../Games/belote/CreateTable/graphql/BeloteCreateOpenTableMutation.graphql"
);

const COINCHE_QUERY = loader(
  "../../../Games/belote/CreateTable/graphql/BeloteDefaultConfigQuery.graphql"
);
const COINCHE_MUTATION = loader(
  "../../../Games/belote/CreateTable/graphql/CoincheCreateOpenTableMutation.graphql"
);

const HANGMAN_QUERY = loader(
  "../../../Games/hangman/CreateTable/graphql/HangmanDefaultConfigQuery.graphql"
);
const HANGMAN_MUTATION = loader(
  "../../../Games/hangman/CreateTable/graphql/HangmanCreateOpenTableMutation.graphql"
);

const TICTACTOE_QUERY = loader(
  "../../../Games/tictactoe/CreateTable/graphql/TicTacToeDefaultConfigQuery.graphql"
);
const TICTACTOE_MUTATION = loader(
  "../../../Games/tictactoe/CreateTable/graphql/TicTacToeCreateOpenTableMutation.graphql"
);

export const GAME_OPERATIONS = {
  mpirimpa_el: {
    query: MPIRIMPA_QUERY,
    mutation: MPIRIMPA_MUTATION,
  },
  mpirimpa_cy: {
    query: MPIRIMPA_QUERY,
    mutation: MPIRIMPA_MUTATION,
  },
  tichu: {
    query: TICHU_QUERY,
    mutation: TICHU_MUTATION,
  },
  backgammon_classic: {
    query: BACKGAMMON_QUERY,
    mutation: BACKGAMMON_MUTATION,
  },
  backgammon_portes: {
    query: BACKGAMMON_QUERY,
    mutation: BACKGAMMON_MUTATION,
  },
  belote: {
    query: BELOTE_QUERY,
    mutation: BELOTE_MUTATION,
  },
  hangman: {
    query: HANGMAN_QUERY,
    mutation: HANGMAN_MUTATION,
  },
  coinche: {
    query: COINCHE_QUERY,
    mutation: COINCHE_MUTATION,
  },
  tictactoe: {
    query: TICTACTOE_QUERY,
    mutation: TICTACTOE_MUTATION,
  },
};
